export const dataHooks = {
    input: 'input-element',
    suffix: 'input-suffix',
    prefix: 'input-prefix',
    tooltip: 'input-tooltip',
    statusIcon: 'input-statusIcon',
};
//# sourceMappingURL=constants.js.map